module.exports = __webpack_public_path__ + "static/media/vorxis-5.aef63590.jpg";